import {apiEnvironment} from '../smoothr-web-app-core/environments/apiEnvironment';

export const hausmannsCustomerGroup = 'hausmanns';
export const customerGroup = hausmannsCustomerGroup;

const supportEmail = {
	hausmanns: 'hausmanns@smoothr.de'
};
const firebaseConfig = {
	hausmanns: {
		apiKey: 'AIzaSyB1Y4wG6BoFE2hi8irI30ofKfscXoEPPDw',
		authDomain: 'prod-env-smoothr.firebaseapp.com',
		databaseURL: 'https://prod-env-smoothr.firebaseio.com',
		projectId: 'prod-env-smoothr',
		storageBucket: 'prod-env-smoothr.appspot.com',
		messagingSenderId: '640058019537',
		appId: '1:640058019537:web:825ca161be7689f6cbfff0',
		measurementId: 'G-WZ7X8KCTBX'
	}
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: 'https://hausmanns-restaurant.com/wp-content/uploads/2023/09/HM_Allergen-Uebersicht_FOOD23.pdf',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140
};
